import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 24px;
`;

const Title = styled.h1`
  font-size: 48px;
  line-height: 56px;
  margin: 0 0 12px 0;
  color: #0f172a;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #475569;
  margin: 0 0 24px 0;
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
`;

const PrimaryButton = styled.button`
  padding: 10px 16px;
  background: #005e9e;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
`;

const SecondaryButton = styled.button`
  padding: 10px 16px;
  background: transparent;
  color: #005e9e;
  border: 1px solid #005e9e;
  border-radius: 6px;
  cursor: pointer;
`;

export default function NotFound(): JSX.Element {
  return (
    <Wrapper>
      <Title>404</Title>
      <Subtitle>Trang bạn tìm không tồn tại hoặc đã được di chuyển.</Subtitle>
      <Actions>
        <PrimaryButton onClick={() => (window.location.href = "/")}>Về trang chủ</PrimaryButton>
        <SecondaryButton onClick={() => window.history.back()}>Quay lại</SecondaryButton>
      </Actions>
    </Wrapper>
  );
}



